import type { ApiEnvelope, ServiceStatusView } from 'shared';
import { apiBaseURL } from './client';

export async function fetchServiceStatus(): Promise<ServiceStatusView> {
  const response = await fetch(`${apiBaseURL}/system/service-status`, {
    cache: 'no-store',
    credentials: 'omit',
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) throw new Error('服务状态暂时无法获取');
  const body = (await response.json()) as ApiEnvelope<ServiceStatusView>;
  if (!body.data) throw new Error('服务状态响应无效');
  return body.data;
}
